import * as React from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import SeccionInfo from "./SeccionInformacion";
import Detalles from "./Detalles";

const styles = () => ({
  container: { padding: "50px" },
  labelTitle: { color: "#128bcc", fontSize: "1.3rem", padding: "0px" },
  infoLabel: { color: "#000", fontSize: "1.2rem", padding: "0px" },
  infoList: { display: "flex", flexDirection: "column" },
  seccionInfo: { paddingTop: "30px" },
  fontSize: { fontSize: "1.2rem" },
  label: { color: "#128bcc" },
  dsObservaciones: { marginTop: "100px" },
});

const Previsualisacion = ({ documento, emisor, classes }) => {
  const getCiudadText = () =>
    `${emisor.ciudadEmisor.dsNombre} - ${
      emisor.ciudadEmisor.departamento.dsNombre
    }`;

  return (
    <Grid container spacing={8} className={classes.container}>
      <Grid item xs={8}>
        <img src={emisor.logoCloud} alt="logo" />
      </Grid>
      <Grid item xs={4} />
      <Grid container>
        <Grid item xs={8}>
          <SeccionInfo
            classes={classes}
            title="Información Emisor"
            info={[
              { title: "Emisor:", value: emisor.fullName },
              { title: "Nit:", value: emisor.identificacionEmisor },
              { title: "Direccion:", value: emisor.direccion },
              { title: "Teléfono:", value: emisor.telefono },
              { title: "Ciudad:", value: getCiudadText() },
            ]}
          />
          <SeccionInfo
            classes={classes}
            title="Información Cliente"
            info={[
              {
                title: "Cliente:",
                value: `${documento.nombresAdquiriente ||
                  ""} ${documento.segundoNombre ||
                  ""} ${documento.primerApellido ||
                  ""} ${documento.segundoApellido || ""}`,
              },
              {
                title: `${documento.tipoIdentificacionAdquiriente ||
                  "Identificacion"}:`,
                value: documento.identificacionAdquiriente || "",
              },
              {
                title: "Dirección:",
                value: documento.direccionAdquiriente || "",
              },
              {
                title: "Teléfono:",
                value: documento.telefonoAdquiriente || "",
              },
              { title: "Email:", value: documento.emailAdquiriente || "" },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <SeccionInfo
            classes={classes}
            info={[
              {
                title: "Fecha Emisión:",
                value: documento.fechaEmision,
                styledTitle: true,
              },
              {
                title: "Fecha Vencimiento:",
                value: documento.fechaVencimiento,
                styledTitle: true,
              },
              {
                title: "Moneda:",
                value: documento.moneda,
                styledTitle: true,
              },
              {
                title: "Forma de Pago:",
                value: documento.pago.formaPago,
                styledTitle: true,
              },
              {
                title: "Medio de Pago:",
                value: documento.pago.medioPago,
                styledTitle: true,
              },
            ]}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Detalles detalles={documento.detalles} documento={documento} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.dsObservaciones}>
            Observaciones:{" "}
            {documento.dsObservaciones || documento.dsObservacion}
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Previsualisacion);
